module.exports = __webpack_public_path__ + "static/RyeBran-2410f7769b85bc54e34cfcc679d6daee.webp";